import { client as request } from "../../api/request";

/**
 * 社内タスク
 */
export interface ConstructionTask {
  id: number;
  serviceTaskTypeId: number;
  name: string;
  shortName: string;
  turn: number;
  clear: number;
}

/**
 * 社内タスクの一覧を取得する
 */
export async function getConstructionTasks(): Promise<ConstructionTask[]> {
  const response = await request.get("get_m_construction_task.php");
  return response;
}

/**
 * 特定の社内タスクを取得する
 */
export async function getConstructionTask(
  id: number
): Promise<ConstructionTask | null> {
  const response = await request.get("get_m_construction_task.php", {
    id
  });
  return response[0] || null;
}

export interface SaveConstructionTaskCommand {
  id?: number;
  serviceTaskTypeId: string;
  name: string;
  shortName: string;
  alignment: string;
  clear: string;
}

/**
 * 社内タスクを保存する
 */
export async function saveConstructionTask(
  command: SaveConstructionTaskCommand
): Promise<number> {
  const data = new FormData();
  if (command.id) {
    data.append("constructionTask[id]", String(command.id));
  }
  data.append("constructionTask[serviceTaskTypeId]", command.serviceTaskTypeId);
  data.append("constructionTask[name]", command.name);
  data.append("constructionTask[turn]", command.alignment);
  data.append("constructionTask[clear]", command.clear);
  data.append("constructionTask[shortName]", command.shortName);

  const res = await request.post("save_m_construction_task.php", data);
  return res.constructionTaskId;
}

/**
 * 工事内容を削除する
 *
 * @deprecated 使ってない
 */
export async function deleteConstructionTask(id: any) {
  await request.post("delete_m_construction_task.php", {}, { id });
}
